module.exports = __webpack_public_path__ + "img/img2.f418e401.png";